import { objectOf, maybe } from "@altostra/type-validations";
import { boolean, number } from "@altostra/type-validations/lib/primitives";

import type { CanvasAudiencePreviewResult, PreviewChannelStatistic } from "./types";

const isChannelStatistic = maybe(
  objectOf<PreviewChannelStatistic>({
    total: number,
    revenue: number,
    margin_of_error: maybe(number),
  })
);

export const isCanvasAudiencePreviewResult = objectOf<CanvasAudiencePreviewResult>({
  distributed: boolean,
  summary_statistics: objectOf({
    estimated: boolean,
    total_app_users: number,
    total_segment_users: number,
    total_segment_users_margin_of_error: maybe(number),
    revenue_total_in_cents: maybe(number),
    channel_statistics: maybe(
      objectOf({
        email: isChannelStatistic,
        iosPush: isChannelStatistic,
        androidPush: isChannelStatistic,
        webPush: isChannelStatistic,
        kindlePush: isChannelStatistic,
      })
    ),
  }),
  is_cached: maybe(boolean),
  calculated_at: maybe(number),
});
